import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=05c7711f"
import script from "./AudioPlayer.vue?vue&type=script&lang=ts"
export * from "./AudioPlayer.vue?vue&type=script&lang=ts"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=05c7711f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports